namespace $.$$ {
	$mol_style_define($bog_blitz_radio, {
		Menu: {
			flex: { direction: 'column' },
			padding: { top: '0.5rem', bottom: '0.5rem', left: '0.5rem', right: '0.5rem' },
			gap: '0.25rem',
			minWidth: '12rem',
		},
		Volume_row: {
			justify: { content: 'center' },
			align: { items: 'center' },
			gap: '0.25rem',
		},
		Volume_label: {
			font: { size: '0.875rem' },
			minWidth: '4rem',
			textAlign: 'center',
		},
		Stop_button: {
			justify: { content: 'center' },
		},
		Station: {
			justify: { content: 'flex-start' },
		},
	})
}
